// Hằng số + tiện ích cho tính năng Đào tạo (khớp mobile-app-v2/src/modules/training).

export const DOCUMENT_TYPE = {
  ALL: "ALL",
  PDF: "PDF",
  DOCX: "DOCX",
  MP3: "MP3",
  MP4: "MP4",
  IMAGE: "IMAGE",
  OTHER: "OTHER",
  LINK: "LINK",
};

export const DOCUMENT_TYPE_LABEL = {
  ALL: "Tất cả",
  PDF: "PDF",
  DOCX: "DOCX",
  MP3: "MP3",
  MP4: "MP4",
  IMAGE: "Ảnh",
  OTHER: "Khác",
  LINK: "Link",
};

// Thứ tự hiển thị trong dropdown lọc "Tất cả"
export const DOCUMENT_TYPE_FILTER_OPTIONS = [
  DOCUMENT_TYPE.ALL,
  DOCUMENT_TYPE.PDF,
  DOCUMENT_TYPE.DOCX,
  DOCUMENT_TYPE.MP3,
  DOCUMENT_TYPE.MP4,
  DOCUMENT_TYPE.IMAGE,
  DOCUMENT_TYPE.OTHER,
  DOCUMENT_TYPE.LINK,
].map((key) => ({ key, label: DOCUMENT_TYPE_LABEL[key] }));

export const LESSON_TAB = {
  INFO: "INFO",
  DOCUMENT: "DOCUMENT",
  QUESTION: "QUESTION",
};

// Tab mặc định = Tài liệu (khớp app)
export const LESSON_TABS = [
  { key: LESSON_TAB.INFO, title: "Thông tin chung" },
  { key: LESSON_TAB.DOCUMENT, title: "Tài liệu" },
  { key: LESSON_TAB.QUESTION, title: "Câu hỏi" },
];

// Giải mã entity HTML (mô tả trong DB có thể bị mã hoá &lt; &gt; ...), tối đa 2 lớp.
const decodeEntities = (s) => {
  let out = String(s || "");
  for (let i = 0; i < 2; i++) {
    out = out
      .replace(/&lt;/gi, "<")
      .replace(/&gt;/gi, ">")
      .replace(/&amp;/gi, "&")
      .replace(/&nbsp;/gi, " ")
      .replace(/&#39;/g, "'")
      .replace(/&quot;/gi, '"');
  }
  return out;
};

// Chuyển HTML mô tả -> văn bản thuần, giữ xuống dòng (khớp htmlToPlainText của app).
export const htmlToPlainText = (html) => {
  if (!html) return "";
  const withBreaks = String(html)
    .replace(/<\s*br\s*\/?\s*>/gi, "\n")
    .replace(/<\/\s*(p|div|li|h[1-6]|tr|blockquote)\s*>/gi, "\n")
    .replace(/<[^>]+>/g, "");
  return decodeEntities(withBreaks)
    .replace(/[^\S\n]+/g, " ")
    .replace(/ *\n */g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
};
